'use client'

import classNames from 'classnames'
import type { HTMLAttributes, ReactNode } from 'react'

interface ITableBodyProps extends HTMLAttributes<HTMLTableSectionElement> {
  className?: string
  children: ReactNode
}

export const PktTableBody = ({ id, children, className, ...props }: ITableBodyProps) => (
  <tbody id={id} className={classNames(className, 'pkt-table__body', {})} {...props} role="rowgroup">
    {children}
  </tbody>
)
